import React from 'react';
import FlagFootballPlayDesigner from './components/FlagFootballPlayDesigner';

function App() {
  return (
    <div className="App">
      <FlagFootballPlayDesigner />
    </div>
  );
}

export default App;